import React, { Component, PropTypes } from 'react'
import { browserHistory, withRouter } from 'react-router'
import { connect } from 'react-redux'
import autoBind from 'react-autobind'
import _ from 'lodash'
import getMuiTheme from 'material-ui/styles/getMuiTheme'
import baseTheme from 'material-ui/styles/baseThemes/lightBaseTheme'
import { fetchItem, editItem, deleteItem, clearItemsErrors } from '../actions/'
import EditItem from '../components/items/EditItem'
import Alert from '../components/home/Alert'

const propTypes = {
  dispatch: PropTypes.func.isRequired,
  isAuthenticated: PropTypes.bool.isRequired,
  item: PropTypes.any,
  items: PropTypes.any,
  itemId: PropTypes.string.isRequired,
  error: PropTypes.any,
}

class ItemEditPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      viewRedirect: false,
      alertOpen: false,
      alertMessage: '',
      edited: false,
    };
    autoBind(this);
  }
  getChildContext() {
    return { muiTheme: getMuiTheme(baseTheme) };
  }
  componentWillMount() {
    if (!this.props.isAuthenticated) {
      browserHistory.push('/');
    }
  }
  componentDidMount() {
    this.props.dispatch(fetchItem(this.props.itemId));
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.error) {
      this.setState({
        alertOpen: true,
        edited: false,
        alertMessage: `${nextProps.error.statusCode} ${nextProps.error.error} ${nextProps.error.message}`,
        error: true,
      });
    }
    if (nextProps.item && !nextProps.error && this.state.edited) {
      this.setState({
        alertOpen: true,
        alertMessage: 'Product item edited succesfully!',
        error: false,
      });
    }
  }
  itemDelete(itemId) {
    const items = this.props.items;
    items.delete = true;
    this.setState({ items });
    this.props.dispatch(deleteItem(itemId));
    browserHistory.push('/items?page=1');
  }
  navigateToView(item) {
    const nextState = this.state;
    nextState.viewRedirect = true;
    nextState.edited = true;
    this.setState(nextState);
    const pItem = item;
    delete pItem.assignedOnly;
    this.props.dispatch(editItem(pItem));
  }
  alertHandleClose() {
    this.setState({
      alertOpen: false,
      edited: false,
      alertMessage: '',
    });
    this.props.dispatch(clearItemsErrors());
    if (!this.state.error) {
      if (this.state.viewRedirect === true) {
        this.setState({ viewRedirect: false });
        browserHistory.push(`/items/view/${this.props.item.id}`);
      } else {
        browserHistory.push('/items?page=1');
      }
    }
  }
  render() {
    const authPage = {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-between',
    };
    return (
      <div className="items component" style={authPage}>
        <Alert
          alertOpen={this.state.alertOpen}
          alertHandleClose={() => this.alertHandleClose()}
          alertMessage={this.state.alertMessage}
        />
        <EditItem
          item={this.props.item}
          onSave={data => this.saveEditItem(data, selectedPreview)}
          onDelete={data => this.itemDelete(data)}
          onView={data => this.navigateToView(data)}
        />
      </div>
    );
  }
}

ItemEditPage.childContextTypes = {
  muiTheme: PropTypes.object.isRequired,
};

ItemEditPage.propTypes = propTypes;

function mapStateToProps(state, ownProps) {
  return {
    isAuthenticated: state.auth.isAuthenticated,
    item: state.items.item,
    items: state.items,
    itemId: ownProps.params.id,
    error: state.items.error,
  };
}

export default withRouter(connect(mapStateToProps)(ItemEditPage));



// WEBPACK FOOTER //
// ./src/containers/ItemEditPage.js